export default __webpack_public_path__ + "static/media/tl.41135123.svg";